import { Injectable } from '@angular/core';

import { ILocalStorageProvider, LocalStorageService } from '../../../gamma/localstorage';

@Injectable()
export class U2000_LocalStorageProvider implements ILocalStorageProvider {
    service: LocalStorageService;
}
